__turbopack_context__.v({
  "blinker": "index-module-scss-module__izBBeW__blinker",
  "book": "index-module-scss-module__izBBeW__book",
  "box": "index-module-scss-module__izBBeW__box",
  "button": "index-module-scss-module__izBBeW__button",
  "buttonWhite": "index-module-scss-module__izBBeW__buttonWhite",
  "continue": "index-module-scss-module__izBBeW__continue",
  "error": "index-module-scss-module__izBBeW__error",
  "footer": "index-module-scss-module__izBBeW__footer",
  "header": "index-module-scss-module__izBBeW__header",
  "inner": "index-module-scss-module__izBBeW__inner",
  "input": "index-module-scss-module__izBBeW__input",
  "leftColumn": "index-module-scss-module__izBBeW__leftColumn",
  "loading": "index-module-scss-module__izBBeW__loading",
  "message": "index-module-scss-module__izBBeW__message",
  "navContainer": "index-module-scss-module__izBBeW__navContainer",
  "planTitle": "index-module-scss-module__izBBeW__planTitle",
  "restartButton": "index-module-scss-module__izBBeW__restartButton",
  "rightColumn": "index-module-scss-module__izBBeW__rightColumn",
  "title": "index-module-scss-module__izBBeW__title",
  "vector": "index-module-scss-module__izBBeW__vector",
});
